(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-countdown"]) return;
  try {
    
  var dataEl = document.getElementById('js-data-shipping-countdown');
  if (!dataEl) return;

  var data = JSON.parse(dataEl.textContent);
  
  var currentTime = moment().tz(data.timezone);
  var cutoffTime = currentTime.clone().hour(data.cutoff).minute(0).second(0);
  var shippingTime = currentTime.clone().add(data.delay, 'day');

  if (currentTime.isAfter(cutoffTime)) {
    cutoffTime.add(1, 'day');
    shippingTime.add(1, 'day'); 
  }

  if (currentTime.isAfter(cutoffTime) && !data.shipping_wed && shippingTime.format('dd') === 'We') {
    shippingTime.add(0, 'day');
	}

  if (currentTime.isAfter(cutoffTime) && !data.shipping_fri && shippingTime.format('dd') === 'Fr') {
    shippingTime.add(3, 'day');
	}

  if (!data.shipping_sat && shippingTime.format('dd') === 'Sa') {
    shippingTime.add(2, 'day');
  }

  if (data.shipping_sun && shippingTime.format('dd') === 'Su') {
    shippingTime.add(1, 'day'); 
  }

  var hoursLeft = cutoffTime.diff(currentTime, 'hours');
  var minutesLeft = cutoffTime.diff(currentTime, 'minutes');
  var clearMinutes = minutesLeft % 60;
  
  var todayTime = currentTime.clone();
  var tomorrowTime = currentTime.clone().add(1, 'day'); 

  var dateLabel = shippingTime.isSame(tomorrowTime, 'day') ? 'same day shipping' : 'shipping on ' + shippingTime.format('MMM D');
  
 

  var countdownLabel = hoursLeft > 0 ? hoursLeft + 'h ' + clearMinutes + 'm' : clearMinutes + 'm'; 

  var productMessage = data.content
                      .replace('{countdown}', '<strong>' + countdownLabel + '</strong>') 
                      .replace('{date}', '<strong>' + dateLabel + '</strong>');

  var targetEl = document.querySelector(data.selector)

  if (targetEl) {
    targetEl.innerHTML = productMessage;
  }

  } catch(e) { console.error(e); }
})();
})();
